import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { observer } from "mobx-react-lite";
import { Link, useNavigate } from "react-router-dom";
import { Context } from "../..";
import styles from './LoginForm.module.scss';

type FormValues = {
  email: string;
  password: string;
};

/**
 * Represents the login form component.
 */
const LoginForm: React.FC = () => {
  const { store } = useContext(Context);
  const { register, handleSubmit, formState: { errors } } = useForm<FormValues>();
  const navigate = useNavigate();

  /**
   * Handles the form submission.
   * @param data - The form data.
   */
  const onSubmit = async (data: FormValues) => {
    const response = await store.login(data.email, data.password);
    const redirectUrl = store.redirectPath || '/';

    if (response?.status === 200) {
      navigate(redirectUrl);
    } else {
      alert(response?.data?.message || 'Помилка авторизації');
    }
  };

  return (
    <form className={styles['form__block']} onSubmit={handleSubmit(onSubmit)}>
      <fieldset className={styles['form__field']}>
        <label className={styles['form__label']} htmlFor="email">Ваш email</label>
        <input
          className={styles['form__input']}
          id="email"
          type="email"
          {...register('email', { required: 'Це поле обов`язкове', pattern: /^\S+@\S+\.\S+$/ })}
        />
        {errors.email && <p className={styles['error-message']}>{errors.email.message}</p>}
      </fieldset>
      <fieldset className={styles['form__field']}>
        <label className={styles['form__label']} htmlFor="password">Ваш пароль</label>
        <input
          className={styles['form__input']}
          id="password"
          type="password"
          {...register('password', { required: 'Це поле обов`язкове', minLength: { value: 8, message: 'Пароль має бути не менше 8 символів' } })}
        />
        {errors.password && <p className={styles['error-message']}>{errors.password.message}</p>}
      </fieldset>
      <button className={styles['form__submit']} type="submit">Увійти</button>
      <Link className={styles['form__link']} to="/registration">Зареєструватись</Link>
      {/* <Link className={styles['form__link']} to="/restore">Відновити пароль</Link> */}
    </form>
  );
};

export default observer(LoginForm);
